import request from '../../axios';

export const getSuggestAdvertisement = async (subBrandId: number) => {
  const {data}: {data: IGetSuggestAdvertisement[]} = await request.get(
    `api/v2/store/advertisement/suggest/sub-brand/${subBrandId}`,
  );

  return data;
};
